import React from 'react';
import { Divider, Typography } from '@mui/material';
import gulMorich from '../../../../../images/Agri-info/crops/Black-Pepper_গোল মরিচ.png';
import useDocumentTitle from '../../../../../hooks/useDocumentTitle';

const GulMorichInfo = () => {

    // dynamic title
    useDocumentTitle("গোল মরিচ");

    return (

        <div className=" rounded-3 bg-white my-4 px-5">
            <Typography
                sx={{
                    textAlign: "center",
                    pb: 2,
                    pt: 3,
                    fontWeight: 600,
                    color: 'rgb(37, 36, 36, 0.83)'
                }}
                variant="h4"
                noWrap
                component="div"
            >
                গোল মরিচ
            </Typography>
            <Divider />

            <div className="card mt-4 mb-3 border-0 rounded-0">
                <div className="row g-0">
                    <div className="col-md-4">
                        <img src={gulMorich} className="img-fluid rounded-0 h-100" alt="..." />
                    </div>
                    <div className="col-md-8">
                        <div className="card-body text-start ">
                            <p className="card-text fw-bold">পুষ্টিমূল্যঃ </p>
                            <p className="card-text">গোল মরিচে আমিষ, চর্বি এবং প্রচুর পরিমাণে ক্যারোটিন, ক্যালসিয়াম ও লৌহ থাকে।</p>

                            <p className="card-text fw-bold">ভেষজগুণঃ</p>
                            <p className="card-text">
                                ১.    হজমে সহায়তা করে<br />
                                ২.    স্নায়ু শক্তি বাড়ায়<br />
                                ৩.    দাঁতের ব্যাথা কমানোতে সহায়তা করে<br />
                                ৪.    মাংসপেশী ও হাড়ের জোড়ার ব্যাথা উপশম করে<br />
                                ৫.    কোষ্ঠকাঠিন্য দূর করে</p>

                            <p className="card-text fw-bold">ব্যবহারঃ </p>
                            <p className="card-text">মসলা হিসেবে গোল মরিচের ব্যবহার রয়েছে।</p>

                        </div>
                    </div>
                </div>
            </div>

            <div className='text-start pb-5'>

                <p className="card-text fw-bold">উপযুক্তমাটিওজমিঃ </p>
                <p className="card-text">পর্যাপ্ত বৃষ্টিপাত হয় ও আর্দ্রতা বেশি এমন এলাকায় গোল মরিচ ভাল জন্মে। এ ফসল 100C-400C পর্যন্ত তাপমাত্রা সহ্য করতে পারে। পিএইচ ৪.৫-৬.০ পর্যন্ত এ ফসল ফলানো যায়। পাহাড়ি এলাকার মাটি এ ফসল চাষের জন্য খুব উপযোগী। </p>
                <p><b>জাতপরিচিতিঃ </b>স্থানীয় জাত</p>

                <p className="card-text fw-bold">চারাতৈরিঃ </p>
                <p className="card-text">গোল মরিচে ৩ ধরনের লতা/কান্ড দেখা যায়। ১. প্রধান কান্ড যার পর্বমধ্য বড়,  ২. রানার ডগা (সুট) ও ৩. ফল ধারণকারী পার্শ্বীয় শাখা। রানার ডগা হতে কাটিং এর মাধ্যমে বংশ বিস্তার করা হয়। শীর্ষ ডগা ও ব্যবহার করা যায়। ফেব্র“য়ারী-মার্চ মাসে ২-৩ টি পর্বসন্ধি (গিট) যুক্ত কান্ড কাটিং হিসেবে নার্সারীতে বা পলি ব্যাগ লাগানো হয়। পলি ব্যাগ উর্বর মাটি দিয়ে ভরাট করা হয়। কাটিং-এ ছায়ার ব্যবস্থা রাখা হয় ও প্রয়োজনে সেচ দিতে হয়। মে-জুন মাসে কাটিং লাগানোর উপযোগী হয়।<br />
                    <b>চারা২.৫Íলাগানোঃ</b> গোল মরিচ ঠেস গাছের ছায়ায় লাগাতে হয়। ঠেস গাছ আগে থেকে ২.৫ মি. দূরত্বে লাগিয়ে গোল মরিচের কাটিং লাগানো হয়। ২-৩ টি কাটিং এক গর্তে লাগানো হয়।</p>

                <p className="card-text fw-bold">সারব্যবস্থাপনাঃ </p>
                <p className="card-text">প্রতি গর্তে ৩০০ গ্রাম ইউরিয়া, ১১০ গ্রাম টিএসপি ও ৪৫০ গ্রাম পটাশ দিতে হয়। তবে এ পরিমাণ সার তৃতীয় বছর হতে দিতে হবে। এ পরিমাণের ১/৩ ভাগ ১ম বছর এবং ২/৩ ভাগ দ্বিতীয় বছরে দিতে হবে। সার সাধারণতঃ বছরে দু’বারে দিতে হয়। একবার মে-জুন মাসে ও পরের বার আগষ্ট-সেপ্টেম্বর মাসে দিতে হয়। এছাড়া প্রতি বছর প্রতি গর্তে মে-জুন মাসে ১০ কেজি পঁচা গোবর ও প্রতি ১ বছর অন্তর-অন্তর প্রতি গর্তে ৬০০ গ্রাম চুন দিতে হবে।</p>

                <p className="card-text fw-bold">সেচ ও আগাছা ব্যবস্থাপনাঃ </p>
                <p className="card-text">আগাছা দেখা দিলে পরিষ্কার করতে হবে ও মাটিতে রসের অভাব হলে পানি সেচ দিতে হবে। ডগা বাড়তে থাকলে  ঠেস গাছের সাথে বেঁধে দিতে হবে।</p>

                <p className="card-text fw-bold">পোকা</p>
                <p><b>পোকার নাম :</b> ফ্লি বিটল</p>
                <p className="card-text fw-bold">ভূমিকা :</p>
                <p className="card-text">এ পোকার আক্রমণে শতকরা ৩০ -৪০ ভাগ  ক্ষতি হতে পারে। সে কারনে এ পোকা দেখা মাত্র প্রয়োজনীয় ব্যবস্থা নিতে হবে।</p>
                <p><b>পোকা চেনার উপায় : </b>পূর্নাঙ্গ বিটল কালো পাখা যুক্ত, মাথা ও ঘাড় হলদে বাদামী বর্ণের।</p>

                <p className="card-text fw-bold">ক্ষতির নমুনা : </p>
                <p className="card-text">-    পূর্ণাঙ্গ ও কীড়া উভয় গাছের কচি অংশ খেয়ে নষ্ট করে ।<br />
                    -    পূর্ণাঙ্গ বিটল ফল ছিদ্র করে ফলের মধ্যে ঢুকে ভেতরের অংশ খায়।<br />
                    -    আক্রান্ত ফল প্রথমে হলুদ ও পরে কালো হয়।<br />
                    -    কীড়া ফলের বীজ ছিদ্র করে ভেতরের অংশ খায় ।</p>
                <p><b>অনুকুল পরিবেশ : </b>ছায়াযুক্ত স্থান।</p>

                <p className="card-text fw-bold">জীবন চক্র : </p>
                <p className="card-text">স্ত্রী বিটল জুলাই মাসে কচি ফলে ১-২ টি ডিম পাড়ে। প্রতিটি পোকা ১০০ টি করে ডিম পাড়ে। ৫-৮ দিনে ডিম থেকে কীড়া বের হয়। কীড়া ২০-৩২ দিন পরে পুত্তলিতে পরিণত হয়। ৬-৭ দিন পর পুত্তলি হতে পূর্ণাঙ্গ বিটল বের হয়। পূর্ণাঙ্গ বিটল ৩৯-৫০ দিন বাঁচে।</p>

                <p className="card-text fw-bold">ব্যবস্থাপনা : </p>
                <p className="card-text">- নিয়মিত গাছ ছাঁটাই করে বৃদ্ধি কমাতে হবে।<br />
                    - অনুমোদিত কীটনাশক প্রয়োগ।</p>

                <p className="card-text fw-bold">রোগব্যবস্থাপনাঃ</p>
                <p className="card-text fw-bold">নার্সারী</p>
                <p className="card-text">নার্সারীতে পাতা পচা ও ঢলে পড়া রোগ দেখা যায়। পাতা পচা রোগে পাতায় কাল দাগ পড়ে এবং ঢলে পড়া রোগ হলে কাটিং নেতিয়ে পড়ে।</p>

                <p className="card-text fw-bold">দমন: </p>
                <p className="card-text">ব্যাভিস্টিন বা কপার অক্সি ক্লোরাইড নামক ছত্রাক নাশক প্রতি দশ লিটার পানিতে ২০ গ্রাম হারে ১০-১২ দিন অন্তর অন্তর ৩ বার প্রয়োগ করলে এ রোগ দমন করা যায়।</p>

                <p className="card-text fw-bold">মাঠে হটাৎ ঢলে পড়া রোগ</p>
                <p className="card-text fw-bold">লক্ষণঃ</p>
                <p className="card-text">
                    ১.    পাতার উপর কালো দাগ পড়ে এবং পরে দাগ বড় হয়।<br />
                    ২.    কচি পাতা ও ডগা আক্রমণে কালো হয়ে যায়। অধিক আক্রমণে গাছ মরে যায়।<br />
                    ৩.    গোড়া সহ সকল স্থানে আক্রমণ ছড়াতে পারে।<br />
                    ৪.    বর্ষা মৌসুমের শেষে আক্রমণ হলে গাছ হলুদ হয়ে ঢলে পড়তে পারে।</p>

                <p className="card-text fw-bold">দমন: </p>
                <p className="card-text">১.    মাটিসহ গাছ তুলে ধ্বংস করা<br />
                    ২.    রোগমুক্ত কাটিং ব্যবহার<br />
                    ৩.    পরিচর্যার সময় শিকড়ে ক্ষত করা যাবেনা<br />
                    ৪.    সাকার (ডগা) মাটিতে বাড়তে দেয়া যাবেনা<br />
                    ৫.    ০.২% হারে কপার অক্সিক্লোরাইড প্রয়োগ</p>

                <p className="card-text fw-bold">ফসলতোলাঃ </p>
                <p className="card-text">মে-জুন মাসে ফুল আসে এবং ৬-৮ মাস পর ফল তোলা যায়। থোকায় ২/১টি ফল উজ্জ্বল কমলা বা বেগুণী হলে সংগ্রহ করে ৭-১০ দিন রোদে শুকিয়ে সংরক্ষণ করা যায়।</p>

            </div>
        </div >


    );
};

export default GulMorichInfo;